import { L8 } from "@adfenix/alexandria";
import cx from "classnames";
import { ReactNode } from "react";
import styled from "styled-components";

const PopoverContainer = styled.div<{ $maxWidth?: number }>`
  .popover-content.popover-content {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => L8(theme.colors.grey)};
    ${({ theme }) => theme.borderRadius.m}
    font-size: 14px;
    max-width: ${x => (x.$maxWidth ? x.$maxWidth : "210px")};
  }

  .popover-content.popover-content:before {
    border-color: transparent;
    background-color: ${({ theme }) => L8(theme.colors.grey)};
    background-color: ${({ theme }) => L8(theme.colors.grey)};
  }
`;

interface PopoverProps {
  trigger: JSX.Element;
  position?: string;
  children: ReactNode;
  style?: Record<string, unknown>;
  maxWidth?: number;
}

const Popover = ({
  trigger: Trigger,
  position = "top",
  children,
  maxWidth,
  ...props
}: PopoverProps) => {
  return (
    <PopoverContainer
      $maxWidth={maxWidth}
      className={cx("popover", {
        [`is-popover-${position}`]: position
      })}
      {...props}
    >
      <Trigger.type {...Trigger.props} className="popover-trigger" />

      <div className={cx("popover-content", {})}>{children}</div>
    </PopoverContainer>
  );
};

export default Popover;
